import { HttpService } from './http.service';
import { Endpoints } from './endpoints';

export abstract class Endpoint {
  constructor(
    protected http: HttpService,
    protected endpointsService: Endpoints
  ) {}
}
